// removed by extract-text-webpack-plugin
module.exports = {"preview":"shopping-icon-element-options__preview___qeDiF","color-text":"shopping-icon-element-options__color-text___7XAdS","colorText":"shopping-icon-element-options__color-text___7XAdS","warning":"shopping-icon-element-options__warning___1bzBt"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/shopping-icon-element-options.css
// module id = 781
// module chunks = 0